import { render, staticRenderFns } from "./alert-notifications.vue?vue&type=template&id=7417389e&scoped=true&"
import script from "./alert-notifications.vue?vue&type=script&lang=js&"
export * from "./alert-notifications.vue?vue&type=script&lang=js&"
import style0 from "./alert-notifications.vue?vue&type=style&index=0&id=7417389e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7417389e",
  null
  
)

export default component.exports